import {Dialog, DialogTitle, DialogContent, DialogActions, Stack} from '@mui/material'

import React, {ReactNode} from 'react'

import {StyledButton} from './style'

type ButtonProps = {
  buttonText: string
  onClick: () => void
  disabled?: boolean
}

interface Props {
  open: boolean
  title: string
  content: ReactNode
  fixed?: ReactNode
  styles?: {
    paper: React.CSSProperties
    content: React.CSSProperties
  }
  cancelButtonProps?: ButtonProps
  confirmButtonProps: ButtonProps
}

/**
 * Modal component
 */
export function Modal(props: Props) {
  const {title, content, cancelButtonProps, fixed, styles, confirmButtonProps, open} = props
  return (
    <Dialog open={open} onClose={() => undefined} PaperProps={{style: styles?.paper}}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={styles?.content}>{content}</DialogContent>
      <DialogActions>
        {fixed}
        <Stack style={{flexDirection: 'row', gap: '1rem'}}>
          {cancelButtonProps && (
            <StyledButton onClick={cancelButtonProps.onClick} variant="outlined">
              {cancelButtonProps.buttonText}
            </StyledButton>
          )}
          <StyledButton onClick={confirmButtonProps.onClick} variant="contained" disabled={confirmButtonProps.disabled}>
            {confirmButtonProps.buttonText}
          </StyledButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
